// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-list[data-v-038557cf] {
  width: 100%;
  max-height: calc(var(--vh) * 60);
  overflow: auto;
  padding-bottom: 10px;
}
.radio-list .radio[data-v-038557cf] {
  cursor: pointer;
}
.radio-list .selected[data-v-038557cf] {
  color: var(--modal-elem-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/RadioSelect.vue"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gCAAgC;EAChC,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".radio-list[data-v-038557cf] {\n  width: 100%;\n  max-height: calc(var(--vh) * 60);\n  overflow: auto;\n  padding-bottom: 10px;\n}\n.radio-list .radio[data-v-038557cf] {\n  cursor: pointer;\n}\n.radio-list .selected[data-v-038557cf] {\n  color: var(--modal-elem-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
